export default __webpack_public_path__ + "static/media/V346_CoC.a2f27da0.pdf";